import { useState, useEffect } from 'react';
import { TOPIC_KEY } from '../global-constants';

const stateCountValidator = (state) => {
	const { vehicles } = state;
	const newSaveCount = vehicles?.filter(
		(vehicle) => vehicle.newSave === true || vehicle.newSave === 'true'
	).length;
	const newTrackedPriceCount = vehicles?.filter(
		(vehicle) =>
			vehicle.newTrackedPrice === true ||
			vehicle.newTrackedPrice === 'true'
	).length;
	return {
		...state,
		newSaveCount,
		newTrackedPriceCount
	};
};

const useLocalStorage = (localStorageKey, initialLocalStorageValue) => {
	const [storedState, setStoredState] = useState(() => {
		try {
			const item = window.localStorage.getItem(localStorageKey);
			if (item) {
				return JSON.parse(item);
			} else {
				return initialLocalStorageValue;
			}
		} catch (error) {
			return initialLocalStorageValue;
		}
	});

	const storageEventHandler = () => {
		const item = localStorage.getItem(localStorageKey);
		if (item) setStoredState(JSON.parse(item));
	};

	const setStateAndLocalStorage = (newState) => {
		if (newState) {
			const validCountState = stateCountValidator(newState);
			window.localStorage.setItem(
				localStorageKey,
				JSON.stringify(validCountState)
			);
			// Publish the event mycars-user-update topic
			window.DDC.pubsub.publish(TOPIC_KEY);
			setStoredState(validCountState);
		}
	};

	// We subscribe to  DDC.pubsub to listen for changes in localStorage
	useEffect(() => {
		const subscriber = window.DDC.pubsub.subscribe(
			TOPIC_KEY,
			storageEventHandler
		);

		return () => {
			subscriber.unsubscribe();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return { storedState, setStateAndLocalStorage };
};

export default useLocalStorage;
